module.exports = __webpack_public_path__ + "static/media/(000055).014a50f3.jpg";